module.exports = __webpack_public_path__ + "media/images/arrow2-70600e4bd67c16b952d0d8c6a1534b04.png";